import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { History, RefreshCw, CheckCircle2, XCircle, ShieldAlert } from "lucide-react";

const fmt = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

const SCOPE_LABEL = { staff: "Admin / staff", enseigne: "Enseigne" };

export const AccessLog = () => {
  const [logs, setLogs] = useState([]);
  const load = () => api.get("/access-logs").then((r) => setLogs(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  return (
    <Card className="mt-6 overflow-hidden" data-testid="access-log">
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border p-4">
        <div className="flex items-center gap-2">
          <History className="h-5 w-5 text-primary" />
          <div>
            <h3 className="font-display font-bold">Journal des accès</h3>
            <p className="text-xs text-muted-foreground">100 dernières tentatives de connexion (Admin et enseignes).</p>
          </div>
        </div>
        <Button size="sm" variant="outline" onClick={load} data-testid="refresh-access-log" className="gap-1.5">
          <RefreshCw className="h-3.5 w-3.5" /> Actualiser
        </Button>
      </div>
      <div className="max-h-[420px] overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Identifiant</TableHead>
              <TableHead>Résultat</TableHead>
              <TableHead>IP</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id} data-testid={`access-log-row-${l.id}`}>
                <TableCell className="whitespace-nowrap text-sm">{fmt(l.created_at)}</TableCell>
                <TableCell><Badge variant="outline">{SCOPE_LABEL[l.scope] || l.scope}</Badge></TableCell>
                <TableCell className="font-medium">{l.identifier}</TableCell>
                <TableCell>
                  {l.blocked ? (
                    <Badge variant="outline" className="border-secondary/50 bg-secondary/15 text-secondary" data-testid="log-blocked">
                      <ShieldAlert className="mr-1 h-3 w-3" /> Bloqué (suspendu)
                    </Badge>
                  ) : l.success ? (
                    <Badge variant="outline" className="border-primary/40 bg-primary/10 text-primary">
                      <CheckCircle2 className="mr-1 h-3 w-3" /> Réussi
                    </Badge>
                  ) : (
                    <Badge variant="outline" className="border-destructive/40 bg-destructive/10 text-destructive">
                      <XCircle className="mr-1 h-3 w-3" /> Échec
                    </Badge>
                  )}
                </TableCell>
                <TableCell className="text-xs text-muted-foreground">{l.ip || "—"}</TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && (
              <TableRow><TableCell colSpan={5} className="py-6 text-center text-muted-foreground">Aucune connexion enregistrée.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </Card>
  );
};
